export const isLoadingSelector = state => state.updateCommunity.get('isLoading');
export const formErrorsSelector = state => state.updateCommunity.get('errors');
